import PracticePlay from './component';
import _routes from './routes';

export default PracticePlay;

export const routes = _routes;



// WEBPACK FOOTER //
// ./containers/Group/Homework/PracticePlay/index.js